import script from "./userSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./userSetting.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__